import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { merge, throwError as _throw } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';

import { DlgWorldPreferencesComponent } from './dlg-preferences';

@Injectable()
export class ShowDlgWorldPreferencesService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show(data: any): Promise<void> {
        const dialogRef = this._dialog.open(DlgWorldPreferencesComponent, {
            panelClass: ['--ui'],
            data
        });

        return dialogRef.afterClosed().toPromise();
    }
}
